// extracted by mini-css-extract-plugin
export var copy = "_footer-module--copy--0ab26";
export var footer = "_footer-module--footer--764a3";
export var label = "_footer-module--label--40bd1";
export var line = "_footer-module--line--888c5";
export var social = "_footer-module--social--92dbe";
export var utilityLink = "_footer-module--utilityLink--dcf1a";
export var utilityLinks = "_footer-module--utilityLinks--d8ea2";